import { useEffect, useState } from "react";
import { CalendarDays, Clock, Video, User } from "lucide-react";
import { Reveal } from "./Reveal";
import { EVENT_DATE_ISO } from "./data";

const INFO = [
    { icon: CalendarDays, label: "Tanggal", value: "Minggu, 15 November 2026" },
    { icon: Clock, label: "Waktu", value: "10.00–14.00 WIB" },
    { icon: Video, label: "Platform", value: "Zoom Meeting" },
    { icon: User, label: "Narasumber", value: "Priscillia Ester, S.T., M.M." },
];

const useCountdown = () => {
    const target = new Date(EVENT_DATE_ISO).getTime();
    const calc = () => {
        const diff = target - Date.now();
        if (diff <= 0) return null;
        return {
            hari: Math.floor(diff / 86400000),
            jam: Math.floor((diff / 3600000) % 24),
            menit: Math.floor((diff / 60000) % 60),
            detik: Math.floor((diff / 1000) % 60),
        };
    };
    const [time, setTime] = useState(calc);
    useEffect(() => {
        const id = setInterval(() => setTime(calc()), 1000);
        return () => clearInterval(id);
    }, []);
    return time;
};

export const ClassInfo = () => {
    const time = useCountdown();
    return (
        <section id="jadwal" className="relative scroll-mt-20 overflow-hidden bg-[#071B37] py-20 lg:py-28" data-testid="class-info-section">
            <div className="gold-hairline absolute left-0 top-0 h-px w-full" />
            <div className="mx-auto max-w-4xl px-5 lg:px-8">
                <Reveal>
                    <div className="rounded-[2rem] border border-[#DDB56C]/30 bg-gradient-to-b from-[#123E65]/40 to-[#071B37] p-8 shadow-[0_24px_64px_rgba(0,0,0,0.4)] sm:p-12" data-testid="class-info-card">
                        <div className="text-center">
                            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#DDB56C]">Jadwal Kelas</p>
                            <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="class-info-heading">
                                Catat <span className="font-accent italic text-gold-gradient">Jadwal Kelasnya!</span>
                            </h2>
                        </div>
                        <div className="mt-10 grid gap-4 sm:grid-cols-2">
                            {INFO.map((item) => (
                                <div key={item.label} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-5" data-testid={`class-info-${item.label.toLowerCase()}`}>
                                    <div className="rounded-xl border border-[#DDB56C]/30 bg-[#071B37] p-3">
                                        <item.icon className="h-5 w-5 text-[#DDB56C]" strokeWidth={1.5} />
                                    </div>
                                    <div>
                                        <p className="text-xs uppercase tracking-wider text-white/50">{item.label}</p>
                                        <p className="mt-0.5 text-sm font-bold text-white sm:text-base">{item.value}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {time && (
                            <div className="mt-10" data-testid="countdown">
                                <p className="text-center text-xs uppercase tracking-[0.2em] text-white/50">Kelas dimulai dalam</p>
                                <div className="mt-4 flex justify-center gap-3 sm:gap-4">
                                    {[
                                        ["Hari", time.hari],
                                        ["Jam", time.jam],
                                        ["Menit", time.menit],
                                        ["Detik", time.detik],
                                    ].map(([label, val]) => (
                                        <div key={label} className="w-16 rounded-2xl border border-[#DDB56C]/30 bg-[#071B37] py-4 text-center sm:w-20" data-testid={`countdown-${label.toLowerCase()}`}>
                                            <p className="font-accent text-2xl font-bold text-[#DDB56C] sm:text-3xl">{String(val).padStart(2, "0")}</p>
                                            <p className="mt-1 text-[10px] uppercase tracking-wider text-white/50">{label}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <p className="mt-10 text-center text-sm text-white/60" data-testid="class-info-microcopy">
                            Ikuti kelas secara online dari tempatmu berada.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
